import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type CalloutType = 'key-idea' | 'gotcha' | 'example';

// 100-tier tints: the 50-tier fills are lighter than the Latte guide surface
// (#eff1f5) and read as washed-out holes in the page.
const STYLES: Record<CalloutType, { bg: string; border: string; labelColor: string; label: string }> = {
  'key-idea': {
    bg: 'bg-blue-100',
    border: 'border-blue-400',
    labelColor: 'text-blue-700',
    label: 'Key idea',
  },
  'gotcha': {
    bg: 'bg-amber-100',
    border: 'border-amber-400',
    labelColor: 'text-amber-700',
    label: 'Gotcha',
  },
  'example': {
    bg: 'bg-emerald-100',
    border: 'border-emerald-400',
    labelColor: 'text-emerald-700',
    label: 'Example',
  },
};

interface Props {
  type: CalloutType;
  children: ReactNode;
}

export function Callout({ type, children }: Props) {
  const s = STYLES[type];
  return (
    <div className={cn('my-4 rounded border-l-4 px-4 py-3', s.bg, s.border)}>
      <div className={cn('mb-1 text-xs font-bold uppercase tracking-wide', s.labelColor)}>{s.label}</div>
      <div className="text-sm text-guide-text-soft">{children}</div>
    </div>
  );
}
